import React from "react";
import { ButtonGroup, Col, Row } from "react-bootstrap";
import { Camera, Diagram3, FileText, PlayCircle } from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Navbar from "react-bootstrap/Navbar";
import logoImage from "../assets/Logo_Logiroad.webp";

export type ViewType = 'records' | 'cameras' | 'check_videos' | 'campaigns';

interface TopBarProps {
    handleLogout: () => void;
    currentView: ViewType;
    onViewChange: (view: ViewType) => void;
    /** When true, show the admin-only Campaigns view button. */
    isAdmin?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ handleLogout, currentView, onViewChange, isAdmin = false }) => {
    return (
        <Navbar bg="dark" variant="dark" expand="lg">
            <Container fluid>
                <Row className="w-100">
                    {/* Logo and Title */}
                    <Col xs="auto" className="d-flex align-items-center">
                        <Navbar.Brand className="d-flex align-items-center">
                            <Image
                                src={logoImage}
                                alt="Logiroad Logo"
                                height="20"
                                className="me-2"
                            />
                            {/* <h4 className="mb-0 text-white">New Production Chain</h4> */}
                        </Navbar.Brand>
                    </Col>

                    {/* View Selection Buttons */}
                    <Col className="d-flex justify-content-center">
                        <ButtonGroup>
                            <Button
                                variant={currentView === 'records' ? 'light' : 'outline-light'}
                                onClick={() => onViewChange('records')}
                                className="d-flex align-items-center"
                            >
                                <FileText className="me-1" size={16} />
                                Records
                            </Button>
                            <Button
                                variant={currentView === 'cameras' ? 'light' : 'outline-light'}
                                onClick={() => onViewChange('cameras')}
                                className="d-flex align-items-center"
                            >
                                <Camera className="me-1" size={16} />
                                Cameras
                            </Button>
                            <Button
                                variant={currentView === 'check_videos' ? 'light' : 'outline-light'}
                                onClick={() => onViewChange('check_videos')}
                                className="d-flex align-items-center"
                            >
                                <PlayCircle className="me-1" size={16} />
                                Vérification vidéos
                            </Button>
                            {isAdmin && (
                                <Button
                                    variant={currentView === 'campaigns' ? 'light' : 'outline-light'}
                                    onClick={() => onViewChange('campaigns')}
                                    className="d-flex align-items-center"
                                >
                                    <Diagram3 className="me-1" size={16} />
                                    Campaigns
                                </Button>
                            )}
                        </ButtonGroup>
                    </Col>

                    {/* Documentation and Logout Buttons */}
                    <Col xs="auto" className="d-flex align-items-center gap-2">
                        <Button
                            size="sm"
                            variant="outline-light"
                            href="/static/frontend/docs/index.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center"
                            title="Open Documentation"
                        >
                            <FileText className="me-1" size={16} />
                            Docs
                        </Button>
                        <Button size="sm" variant="outline-light" onClick={handleLogout}>
                            Logout
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Navbar>
    );
};

export default TopBar;
